import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import {
  BehaviorSubject, Observable, map, filter, switchMap, tap,
} from 'rxjs';

import { CustomIcons } from '@shared/models/custom-icons';
import { CatalogItemFieldsVM } from '@shared/models/shared-catalog.state';
import { CatalogService } from '@shared/services/catalog.service';
import { CatalogItemTableData } from 'app/modules/data/shared/models/catalog-item-table-data';
import { DownloadFileNames } from 'app/modules/data/modules/catalog-items-data/store/catalog-items.actions';
import { CatalogItemValue } from '../../../../../models/catalog';

@Component({
  selector: 'app-catalog-items-modal',
  templateUrl: './catalog-items-modal.component.html',
  styleUrls: ['./catalog-items-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogItemsModalComponent implements OnInit {
  public icons = CustomIcons;
  public loading = true;
  public redraw = false;
  public globalId: number;
  public title: string;
  public subTitle: string;

  #getCatalogFields = new BehaviorSubject<number | null>(null);
  #getValueFields = new BehaviorSubject<number | null>(null);

  #arr: CatalogItemTableData[] = [];

  public get arr() {
    return this.#arr;
  }

  public set arr(data: CatalogItemTableData[]) {
    this.#arr = data;
    this.#getValueFields.next(+this.arr[0].global_id);
  }

  #catalogId: number;

  public get catalogId(): number {
    return this.#catalogId;
  }

  public set catalogId(catalogId: number) {
    this.#catalogId = catalogId;
    this.#getCatalogFields.next(catalogId);
  }

  public itemData$: Observable<CatalogItemValue> = this.#getValueFields.pipe(
    switchMap((globalId) => this.catalogService.getValueFields({
      criteria: `global_id = ${globalId}`,
      id: this.catalogId,
    })),
    tap(data => {
      this.loading = false;
      this.redraw = false;
      this.store.dispatch(new DownloadFileNames(data.response));
    }),
    map(data => data.response[0]),
  );
  public itemFields$: Observable<CatalogItemFieldsVM[]> = this.#getCatalogFields.pipe(
    filter(Boolean),
    switchMap((catalogId) => this.catalogService.getCatalogInfo(catalogId)),
    map(res => res.response.find(x => x.id === this.catalogId)?.fields ?? []),
  );
  public selectModel = new SelectionModel<number>();

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<CatalogItemsModalComponent>,
    private catalogService: CatalogService,
  ) {}

  public ngOnInit(): void {
    this.subTitle = this.arr[0].value;
    this.selectModel.toggle(+this.arr[0].global_id);
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  public setData(globalId: number, title: string): void {
    this.redraw = true;
    this.subTitle = title;
    this.selectModel.clear();
    this.selectModel.select(globalId);
    this.#getValueFields.next(globalId);
  }
}
